<template>
  <div class="flex justify-center">
    <g-card-page class="sm:mt-5">
      <div :class="$style.banner" class="sm:m-2 sm:rounded-md" />
      <div class="pt-4 pb-8 px-10 sm:px-16">
        <label class="block">
          <span class="text-small">Nama</span>
          <input
            v-model="inputName"
            type="text"
            class="mt-1 block w-full rounded-md border-basic-700
             shadow-sm focus:border-link-500 focus:ring focus:ring-link-300 focus:ring-opacity-50"
            placeholder="Nama Anda"
          >
        </label>

        <label class="block mt-3 relative">
          <span class="text-small">Email </span>
          <input
            v-model="inputEmail"
            type="email"
            :class="[
              'mt-1 block w-full rounded-md shadow-sm focus:ring-opacity-50',
              errorInputClass(isError.mail)
            ]"
            placeholder="Alamat email"
          >
          <span
            v-if="isError.mail"
            class="text-error text-scarlet absolute m-0.5"
            v-text="errorMessage.mail"
          />
        </label>

        <div class="flex items-center mt-3">
          <div class="w-1/3">
            <label class="block">
              <span class="text-small">Kode</span>
              <select
                v-model="inputPhoneCode"
                class="block w-full mt-1 rounded-md border-basic-700 shadow-sm
                focus:border-link-500 focus:ring focus:ring-link-300 focus:ring-opacity-50"
              >
                <option>+62</option>
              </select>
            </label>
          </div>
          <div class="flex-1 pl-2 relative">
            <label class="block">
              <span class="text-small">Nomor Telepon </span>
              <input
                v-model="inputPhone"
                type="number"
                :class="[
                  'mt-1 block w-full rounded-md shadow-sm focus:ring-opacity-50',
                  errorInputClass(isError.phone)
                ]"
                placeholder="No. Telepon"
              >
            </label>
            <span
              v-if="isError.phone"
              class="text-error text-scarlet absolute m-0.5"
              v-text="errorMessage.phone"
            />
          </div>
        </div>

        <label class="block mt-3">
          <span class="text-small">Jumlah Donasi (dalam rupiah) </span>
          <input
            type="text"
            inputmode="numeric"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            class="mt-1 block w-full rounded-md border-basic-700 shadow-sm
            focus:border-link-500 focus:ring focus:ring-link-300 focus:ring-opacity-50"
            placeholder="Rp 0"
            :value="viewDonationValue"
            @beforeinput="guardDonationBeforeInput"
            @input="handleInputDonation"
          >
        </label>

        <g-button
          :loading="isLoading"
          :disabled="isDisableBtnSubmit"
          class="mt-4 w-full"
          label="Lanjutkan"
          @click="handleCLickSubmit"
        />

        <p class="mt-4 text-small text-basic-700">
          Dengan menekan tombol diatas saya setuju dengan
          <span class="text-link-500">Goers Terms and Conditions</span>
          dan
          <span class="text-link-500">Goers Privacy Policy</span>
        </p>

        <div class="flex justify-center">
          <g-powered-by class="my-4" />
        </div>

        <p class="text-small font-bold">
          Butuh bantuan?
        </p>
        <p class="text-label">
          Hubungi kami melalui:
        </p>

        <div class="flex items-center text-basic-700 text-label mt-1">
          <div class="w-1/2">
            <p class="font-bold">
              Chat WhatsApp
            </p>
            <a
              class="text-link-500"
              rel="noopener noreferrer"
              target="_blank"
              href="https://wa.me/6281110588333"
            >
              +6281110588333
            </a>
          </div>
          <div class="w-1/2">
            <p class="font-bold">
              Email
            </p>
            <a class="text-link-500" href="mailto:cs@goersapp.com">
              cs@goersapp.com
            </a>
          </div>
        </div>
      </div>
    </g-card-page>
  </div>
</template>

<script>
import {
  computed, onErrorCaptured, ref, watch, reactive, onMounted,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { GButton, GCardPage, GPoweredBy } from '../components';
import { postDonation } from '../libs/core/services';
import { emailValidation } from '../libs/helper';

const DEFAULT_DONATION_VALUE = 'Rp 0';

export default {
  name: 'Home',
  components: {
    GCardPage,
    GButton,
    GPoweredBy,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const isLoading = ref(false);
    const inputName = ref('');
    const inputEmail = ref('');
    const inputPhone = ref('');
    const inputPhoneCode = ref('+62');
    const inputDonation = ref('');
    const viewDonationValue = ref('');
    const codeParam = computed(() => store.state.codeParam);
    const nameParam = computed(() => store.state.nameParam);
    const vidParam = computed(() => store.state.vidParam);
    const isError = reactive({
      mail: false,
      phone: false,
    });
    const errorMessage = reactive({
      mail: '',
      phone: '',
    });
    const isDisableBtnSubmit = computed(
      () => !inputName.value
        || !inputPhone.value
        || !inputPhoneCode.value
        || !inputDonation.value
        || isError.phone
        || isError.mail,
    );

    function errorInputClass(isInputError) {
      return isInputError
        ? 'focus:border-scarlet focus:ring focus:ring-scarlet border-scarlet'
        : 'border-basic-700 focus:border-link-500 focus:ring focus:ring-link-300';
    }

    const MAX_DIGITS = 12;
    const MAX_VALUE = 999999999999;
    const nf = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 0 });
    function formatRupiahInt(n) {
      return `Rp ${nf.format(n)}`;
    }

    function guardDonationBeforeInput(e) {
      // allow delete/backspace
      if (e.inputType && e.inputType.startsWith('delete')) return;

      // block non-digit characters while typing
      if (e.inputType === 'insertText' && e.data && /\D/.test(e.data)) {
        e.preventDefault();
        return;
      }

      const el = e.target;
      const start = el.selectionStart ?? el.value.length;
      const end = el.selectionEnd ?? el.value.length;
      const data = e.data ?? '';
      const nextRaw = el.value.slice(0, start) + data + el.value.slice(end);
      const nextDigits = nextRaw.replace(/\D+/g, '').replace(/^0+/, '');

      // limit digit length
      if (nextDigits.length > MAX_DIGITS) {
        e.preventDefault();
      }
    }

    function handleInputDonation(e) {
      let digits = (e.target.value || '').replace(/\D+/g, '').replace(/^0+/, '');
      if (digits.length > MAX_DIGITS) digits = digits.slice(0, MAX_DIGITS);

      let n = digits ? Number(digits) : 0;
      if (n > MAX_VALUE) n = MAX_VALUE;

      inputDonation.value = n ? String(n) : '';
      viewDonationValue.value = n ? formatRupiahInt(n) : DEFAULT_DONATION_VALUE;
    }

    function validateInputPhone(firstNumberOnPhoneNumber) {
      if (firstNumberOnPhoneNumber === '0') {
        isError.phone = true;
        errorMessage.phone = 'Nomor Pertama Tidak Boleh 0!';
        return;
      }
      isError.phone = false;
      errorMessage.phone = '';
    }

    function validationInputEmail(email) {
      if (emailValidation(email)) {
        isError.mail = false;
        errorMessage.mail = '';
        return;
      }
      isError.mail = true;
      errorMessage.mail = 'Format Email Salah!';
    }

    async function handleCLickSubmit() {
      isLoading.value = true;
      const response = await postDonation({
        price: inputDonation.value,
        name: inputName.value,
        email: inputEmail.value,
        phone: inputPhoneCode.value + inputPhone.value,
        code: codeParam.value,
        itemName: nameParam.value,
        vid: vidParam.value,
      });
      const link = response.data.payment_link;
      router.push({ name: 'PAYMENT', query: { link } });
      isLoading.value = false;
    }

    function storeCodeNameVidParam() {
      store.commit('SET_CODE_NAME_VID_PARAM', route.query);
    }

    onMounted(() => {
      storeCodeNameVidParam();
    });

    watch(
      () => inputPhone.value,
      () => {
        validateInputPhone(inputPhone.value.charAt(0));
      },
    );
    watch(
      () => inputEmail.value,
      () => {
        validationInputEmail(inputEmail.value);
      },
    );

    onErrorCaptured(() => {
      isLoading.value = false;
    });

    return {
      isLoading,
      isError,
      inputName,
      errorMessage,
      errorInputClass,
      inputEmail,
      inputPhone,
      inputPhoneCode,
      inputDonation,
      handleCLickSubmit,
      handleInputDonation,
      guardDonationBeforeInput,
      isDisableBtnSubmit,
      viewDonationValue,
    };
  },
};
</script>

<style lang="scss" module>
.banner {
  height: 120px;
  background-image: url("../assets/banner-donation.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
//Hide arrow on input phone number
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
